var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMaleBadge = function SvgMaleBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 18,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 16.669,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 16.669,
    x: 0.5,
    y: 0.5,
    stroke: "#7F00FF",
    rx: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7F00FF",
    d: "M12.668 7.069h-1.441v2.343h-1.122V4h1.122v2.123h1.441zm-1.441 6.6h-6.27V9.973h6.27zm-1.122-.891v-1.925H6.09v1.925zm-.968-5.291.154.913c-1.21.286-2.959.418-4.246.429L4 8.84V4.539h1.111v3.333c1.452-.011 2.86-.121 4.026-.385M16.668 9.489a2.908 2.908 0 0 1 2.926-2.915c.693 0 1.276.209 1.782.605l1.177-1.177h-1.078v-.748h2.365v2.365h-.759v-1.1l-1.188 1.188c.396.495.627 1.1.627 1.782a2.932 2.932 0 0 1-2.926 2.926 2.925 2.925 0 0 1-2.926-2.926m.847 0c0 1.144.902 2.134 2.079 2.134 1.166 0 2.079-.99 2.079-2.134 0-1.166-.913-2.134-2.079-2.134-1.177 0-2.079.968-2.079 2.134"
  })));
};
export default SvgMaleBadge;